import { defaultFormItemLayout } from '../../../../modules/FormItems'
import React from 'react'
import { Col, Form } from 'antd/lib/index'
import { dateFormat, dateVal, strVal } from '../../../../modules/Utils'
import { Row } from 'antd'

function PayrollClaimForm (props) {
  const { payrollClaim } = props
  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="From">
            <span>{strVal(payrollClaim, 'company.fn')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Type">
            <span>{strVal(payrollClaim, 'type').toUpperCase()}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Currency">
            <span>{strVal(payrollClaim, 'currency')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Date">
            <span>{dateFormat(dateVal(payrollClaim, 'date'))}</span>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

PayrollClaimForm.propTypes = {}
PayrollClaimForm.defaultProps = {}

export default Form.create()((PayrollClaimForm))
